"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const data_1 = require("./data");
const functions_1 = require("./functions");
const initialState = {
    propertiesSelectors: {
        ["config"]: data_1.initialConfigPvs,
        ["case-0"]: data_1.initialCalculationCasePvs
    },
    results: undefined,
    isLoading: false
};
function reducer(
// biome-ignore lint: -
state = initialState, action) {
    var _a;
    switch (action.type) {
        case "oilon-tool/SET-PROPERTIES": {
            return Object.assign(Object.assign({}, state), { propertiesSelectors: Object.assign(Object.assign({}, state.propertiesSelectors), { [action.id]: action.pvs }) });
        }
        case "oilon-tool/ADD-CASE": {
            const nextCaseIndex = Object.entries(state.propertiesSelectors)
                .filter(([id, _v]) => id.startsWith("case"))
                .map(([key, _state]) => +key.split("-")[1])
                .sort((a, b) => b - a)[0] + 1;
            const propertiesSelectors = Object.assign(Object.assign({}, state.propertiesSelectors), { [`case-${nextCaseIndex}`]: data_1.newCalculationCasePvs });
            return Object.assign(Object.assign({}, state), { results: undefined, propertiesSelectors: propertiesSelectors });
        }
        case "oilon-tool/DELETE-CASE": {
            const propertiesSelectors = Object.keys(state.propertiesSelectors).reduce((soFar, key) => {
                if (key !== action.id) {
                    soFar[key] = state.propertiesSelectors[key];
                }
                return soFar;
            }, {});
            return Object.assign(Object.assign({}, state), { results: undefined, propertiesSelectors: propertiesSelectors });
        }
        case "oilon-tool/CALCULATE": {
            return Object.assign(Object.assign({}, state), { isLoading: true, results: undefined });
        }
        case "oilon-tool/PARSE-RESULT": {
            const calculationCaseResults = (0, functions_1.parseCalculationCasesResults)(action.result.calculationCases);
            const errors = (_a = action.result.errors) !== null && _a !== void 0 ? _a : [];
            return Object.assign(Object.assign({}, state), { isLoading: false, results: {
                    calculationCaseResults: calculationCaseResults,
                    errors: errors
                } });
        }
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
            return state;
    }
}
//# sourceMappingURL=reducer.js.map